import * as getters from "./url.getters";
import * as actions from "./url.actions";
import * as mutations from "./url.mutations";

const state = {
    centerFromUrl: false,
    categoriesFromUrl: [],
    poiDetailFromUrl: false,
    waypointsFromUrl: false,
    interimStopsFromUrl: false,
    transportModeFromUrl: false,
    specialContentFromUrl: false,
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
}